import { render } from "./MenuComponent.vue?vue&type=template&id=2fc5035a"
import script from "./MenuComponent.vue?vue&type=script&lang=ts"
export * from "./MenuComponent.vue?vue&type=script&lang=ts"
script.render = render

export default script